import {
  Alert,
  Button,
  Card,
  CardContent,
  Container,
  TextField,
  Typography,
} from "@mui/material";
import axios from "axios";
import React, { useState, useContext, useEffect } from "react";
import API_BASE_URL from "../../utils/api";

import API_URL from "../../config";
const ForgotPassword = () => {
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");
  const sendResetEmail = async () => {
    setMessage("");
    setError("");
    try {
      await axios.post(`${API_BASE_URL}/auth/forgot-password`, { email });
      setMessage("Check your email for reset instructions");
    } catch (err) {
      setError(err.response?.data?.error || "Failed to send reset email");
    }
  };
  return (
    <Container maxWidth="xs">
      <Card sx={{ mt: 8, boxShadow: 3 }}>
        <CardContent>
          <Typography variant="h4" align="center" gutterBottom>
            Forgot Password
          </Typography>
          <Typography align="center" color="textSecondary" sx={{ mb: 2 }}>
            We will send you an email with instructions to reset your password.
          </Typography>
          {message && (
            <Alert severity="success" sx={{ mb: 2 }}>
              {message}
            </Alert>
          )}
          {error && (
            <Alert severity="error" sx={{ mb: 2 }}>
              {error}
            </Alert>
          )}

          <TextField
            label="Email"
            type="email"
            variant="outlined"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            fullWidth
            sx={{ mb: 2 }}
          />
          <Button
            variant="contained"
            color="primary"
            fullWidth
            onClick={sendResetEmail}
            disabled={!(email.length > 0)}
          >
            Email Me
          </Button>
        </CardContent>
      </Card>
    </Container>
  );
};
export default ForgotPassword;
